<template>
  <div>
    <el-table :data="personList" :row-style="rowStyle" :header-cell-style="headerStyle"
      style="width: 100%" :height="heightNum ? heightNum+'px':'calc(100vh - 285px)'" border @selection-change="selectionchange">
      <el-table-column v-if="checkboxShow" :selectable="checkboxInit" type="selection" width="50" align="center">
      </el-table-column>
      <el-table-column prop="name" label="姓名" align="center">
      </el-table-column>
      <el-table-column prop="username" label="账号" align="center">
      </el-table-column>
      <el-table-column v-if="checkboxShow" label="操作" align="center">
        <template #default="{ row }">
          <span v-if="!row.defaultFlag && deleRoleUserConfig" style="cursor: pointer;color:#EE4C4C"
            @click="delRolePersonHandler(row)">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background :total="totalCount" :page-size="pageSize" :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev, pager, next, jumper"
      style="text-align: end;margin: 8px 0;" @size-change="handleSizeChange" @current-change="currentChange" />
  </div>
</template>

<script>
import priviService from "@/CommonDP/service/privi-service";
import { mapState } from "vuex";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
export default {
  props: {
    checkboxShow: {
      type: Boolean,
      default: true
    },
    heightNum: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      personList: [],
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      keyword: '',
      deleRoleUserConfig: checkPermission(this.$allPerms.ROLEPOWERCONFIG_DELE_ROLEUSER),
      roleID: '',
      roleName: ''
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    })
  },
  mounted() {},
  methods: {
    queryPreson(row) {
      this.keyword = '';
      this.pageIndex = 1;
      this.roleID = row.roleID;
      this.roleName = row.roleName;
      this.keyword = row.keyword;
      this.getPersonList(this.roleID, this.roleName);
    },
    getPersonList(roleId, roleName) {
      const { enterpriseId, pageSize, pageIndex, keyword } = this;
      const type = 0;
      const params = { roleId, enterpriseId, roleName, pageSize, pageNum: pageIndex, keyword, type };
      return priviService.getSysRoleUserList(params).then(({ data, totalCount }) => {
        this.personList = data;
        this.totalCount = totalCount;
      });
    },
    selectionchange(val) {
      this.$emit('setSelectionData', val);
    },

    delRolePersonHandler(row) {
      this.$emit('delRolePersonHandler', row);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.comGetPersonList();
    },
    currentChange(val) {
      this.comGetPersonList(val);
    },
    comGetPersonList(val) {
      this.pageIndex = val || 1;
      const roleID = this.roleID;
      const roleName = this.roleName;
      this.getPersonList(roleID, roleName);
    },
    search(keyword) {
      const name = keyword;
      if (!name) return this.$message.warning("请输入人员姓名或手机号");
      setTimeout(() => {
        this.personList = this.personList.filter(item => this.filterKeyword(item, name));
      }, 500);
    },
    filterKeyword(item, name) {
      const keyArr = ["name", "username"];
      let flag = false;
      while (keyArr[0] && !flag) {
        if (item[keyArr.shift()].includes(name)) flag = true;
      }
      return flag;
    },
    checkboxInit(row) {
      if (row.defaultFlag) {
        return 0;
      } else {
        return 1;
      } // 可勾选
    },
    rowStyle() {
      return "height:60px";
    },
    headerStyle() {
      return "background-color: #F7F9FF;color:#2E384D;padding:6px 0;height:54px;border-top:1px solid #EFF0F9";
    }
  }
};
</script>

<style>

</style>
